import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { bindActionCreators } from 'redux';
import { systemStatusActions } from '../../state/modules/system-status';
/**
 * Healthcheck page view for system status check.
 */
const HealthCheck = (props) => (
  <div style={{ textAlign: 'center', marginTop: '20px' }}>
    <h1>health check</h1>
    <p>{`build version: ${props.health.buildVersion}`}</p>
  </div>
);

const mapStateToProps = (state) => ({
  health: state.systemStatus.health
});

const mapDispatchToProps = (dispatch) => ({
  checkSystemHealth: bindActionCreators(systemStatusActions.systemStatus.health, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.checkSystemHealth()
    }
  })
)(HealthCheck);


// WEBPACK FOOTER //
// ./src/containers/pages/healthcheck.js